export default "__VITE_ASSET__CCZW3zZm__"